import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";

export const eventsBeam = createBeam(bifrost, "/game/events", {
    
});

